module.exports = __webpack_public_path__ + "img/monogram.54568ac0.svg";